@if (!inErrorState) {
    <form class="ap-grid ap-grid-cols-2" [formGroup]="digicodeAanmakenFormGroup" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="ap-col-span-1 ap-col-span-lt-lg-2">
            <fieldset>
                <legend>
                    <h3>
                        {{ 'digicode-aanmaken.username.label' | apContent }}
                    </h3>
                </legend>
                <ap-input
                    data-bb="username"
                    name="username"
                    [label]="'digicode-aanmaken.username.input.label' | apContent"
                    formControlName="username"
                    [messages]="errorMessagesUsername"
                    autocapitalize="off"
                    enterkeyhint="next"
                >
                </ap-input>
                <ap-notification [closeable]="false" status="info">
                    <ap-content key="digicode-aanmaken.username.info.text"></ap-content>
                </ap-notification>
                <legend>
                    <h3>
                        {{ 'digicode-aanmaken.password.label' | apContent }}
                    </h3>
                </legend>
                <ap-input
                    data-bb="password"
                    name="password"
                    [label]="'digicode-aanmaken.password.input.label' | apContent"
                    [type]="showPasswordType()"
                    [messages]="errorMessagesPassword"
                    formControlName="password"
                    autocapitalize="off"
                    enterkeyhint="next"
                    autocomplete="new-password"
                >
                </ap-input>
                <ap-notification [closeable]="false" [status]="'info'">
                    {{ 'digicode-aanmaken.info.text' | apContent }}
                    <ul class="ap-margin-bottom-0">
                        <li>
                            @if (password.digit) {
                                <ap-icon data-bb="iconNumber-check" name="checkmark" color="success" size="small"></ap-icon>
                            }
                            @if (!password.digit) {
                                <ap-icon data-bb="iconNumber-bullet" name="bullet" color="success" size="extra-small"></ap-icon>
                            }
                            {{ 'digicode-aanmaken.minimaal.1.cijfer' | apContent }}
                        </li>
                        <li>
                            @if (password.upperCase) {
                                <ap-icon data-bb="iconCapitalLetter-check" name="checkmark" color="success" size="small"></ap-icon>
                            }
                            @if (!password.upperCase) {
                                <ap-icon data-bb="iconCapitalLetter-bullet" name="bullet" color="success" size="extra-small"></ap-icon>
                            }
                            {{ 'digicode-aanmaken.minimaal.1.hoofdletter' | apContent }}
                        </li>
                        <li>
                            @if (password.lowerCase) {
                                <ap-icon data-bb="iconSmallLetter-check" name="checkmark" color="success" size="small"></ap-icon>
                            }
                            @if (!password.lowerCase) {
                                <ap-icon data-bb="iconSmallLetter-bullet" name="bullet" color="success" size="extra-small"></ap-icon>
                            }
                            {{ 'digicode-aanmaken.minimaal.1.klein.letter' | apContent }}
                        </li>
                        <li class="ap-margin-bottom-0">
                            @if (password.specialChar) {
                                <ap-icon data-bb="iconSpecialCharacters-check" name="checkmark" color="success" size="small"></ap-icon>
                            }
                            @if (!password.specialChar) {
                                <ap-icon data-bb="iconSpecialCharacters-bullet" name="bullet" color="success" size="extra-small"></ap-icon>
                            }
                            {{ 'digicode-aanmaken.minimaal.1.speciaal.teken' | apContent }}
                        </li>
                    </ul>
                </ap-notification>
                <ap-icon-link (click)="toggleType($event)" [iconName]="showPasswordType() === 'password' ? 'eye' : 'eye-slash'" link="#">
                    {{ passwordCheckboxText() }}
                </ap-icon-link>
                <legend>
                    <h3>
                        {{ 'digicode-aanmaken.validate-password.label' | apContent }}
                    </h3>
                </legend>
                <ap-input
                    data-bb="password-validate-input"
                    name="validate-password"
                    [label]="'digicode-aanmaken.validate-password.input.label' | apContent"
                    [type]="showPasswordType()"
                    [messages]="errorMessagesValidatePassword"
                    formControlName="validatePassword"
                    autocapitalize="off"
                    enterkeyhint="next"
                >
                </ap-input>
                <ap-button type="submit" [isDisabled]="digicodeAanmakenFormGroup.invalid">
                    {{ 'digicode-aanmaken.submit.label' | apContent }}
                </ap-button>
            </fieldset>
        </div>
    </form>
}
<ap-error [apError]="apError$ | async"> </ap-error>
